module.exports = __webpack_public_path__ + "static/media/card-bg.8f8bfe33.png";